import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { DispatchItem } from "../models/DispatchItem";
import { Round } from "../models/Round";
import { RoundParameters } from "../models/RoundParameters";
import { CopyRoundParameters } from "../models/CopyRoundParameters";


@Injectable({
    providedIn: 'root'
})
export class RoundsDataService {

    constructor(private http: HttpClient) {

    }

    copyRound(parameters: CopyRoundParameters): Observable<number[]> {
        return this.http.post<number[]>('api/Rounds/CopyRound', parameters);
    }

    getRound(roundId: number): Observable<Round> {
        return this.http.get<Round>('api/Rounds/GetRound/' + roundId);
    }

    getDispatches(parameters: RoundParameters): Observable<DispatchItem[]> {
        return this.http.post<DispatchItem[]>('api/Rounds/GetDispatches', parameters);
    }

    saveRound(round: Round): Observable<number[]> {
        return this.http.post<number[]>('api/Rounds/SaveRound', round);
    }

    deleteRound(roundId: number): Observable<number[]> {
        return this.http.delete<number[]>('api/Rounds/DeleteRound/' + roundId);
    }

}

